import { defaultClient } from "@/shared/lib/axios";
import {
	type ForgotPasswordRequest,
	type ForgotPasswordResponse,
	ForgotPasswordResponseSchema,
	type ResetPasswordRequest,
	type ResetPasswordResponse,
	ResetPasswordResponseSchema,
	type ResetRequest,
	type ResetRequestResponse,
	ResetRequestResponseSchema,
	type ResetVerify,
	type ResetVerifyResponse,
	ResetVerifyResponseSchema,
} from "./password.types";

const PASSWORD_ENDPOINT = "/password";

export const passwordApi = {
	forgot: async (request: ForgotPasswordRequest): Promise<ForgotPasswordResponse> => {
		const { data } = await defaultClient.post(`${PASSWORD_ENDPOINT}/forgot`, request);
		return ForgotPasswordResponseSchema.parse(data);
	},

	reset: async (request: ResetPasswordRequest): Promise<ResetPasswordResponse> => {
		const { data } = await defaultClient.post(`${PASSWORD_ENDPOINT}/reset`, request);
		return ResetPasswordResponseSchema.parse(data);
	},

	resetRequest: async (request: ResetRequest): Promise<ResetRequestResponse> => {
		const { data } = await defaultClient.post(`${PASSWORD_ENDPOINT}/reset-request`, request);
		return ResetRequestResponseSchema.parse(data);
	},

	resetVerify: async (request: ResetVerify): Promise<ResetVerifyResponse> => {
		const { data } = await defaultClient.post(`${PASSWORD_ENDPOINT}/reset-verify`, request);
		return ResetVerifyResponseSchema.parse(data);
	},
};
